import ServiceExec from '@/common/utils/ServiceExec';
import { order } from '@/common/service/ApiList';
import { toastAlert, FORM } from '@/common/utils/Toast';
import { customToast } from '@/common/utils/ToastServiceResult';
import store from '@/store';
const { getList, detail, state, partialRefund, memo } = order;

export default {
  FETCH_ORDER: async ({ commit }, params) => {
    const userData = store.getters['admin/loginData'];
    if (!userData) return;
    params.userNo = userData.userNo;
    params.includeProductCount = false;

    commit('setConditions', params);
    const { status, data } = await ServiceExec.get(getList, params);

    if (status !== 200) return;
    const { pageInfo, list } = data;
    commit('setPageInfo', pageInfo);
    commit('setList', list);
  },
  FETCH_ORDER_DETAIL: async ({ commit, rootGetters }, { orderNo }) => {
    const { store } = rootGetters['admin/loginData'];
    const storeNos = store?.map((elem) => elem.storeNo) ?? [];
    const { status, data } = await ServiceExec.get(detail(orderNo), { storeNos });
    if (status !== 200) {
      customToast(status, data, '');
      setTimeout(() => {
        location.href = '/';
      }, 2000);
    }

    commit('setDetail', data);
  },
  SAVE_MEMO: async ({ commit }, { orderNo, memoData }) => {
    const { status, data } = await ServiceExec.patch(memo, { memo: memoData, orderNo });

    if (status === 200) toastAlert('저장에 성공했습니다.', 'success');
    else toastAlert(data, 'error');
  },
  CHANGE_STATUS: async (
    { commit, getters },
    param = {
      orderNo: 0,
      userNo: 0,
      orderManageNo: null,
      orderState: null,
      orderType: null,
      duration: null,
      cancelReason: null,
      nameKr: '',
      nameVn: ''
    }
  ) => {
    const { status, data } = await ServiceExec.patch(state, param);
    if (data) {
      const orderListState = getters['getList'];
      orderListState.forEach((e, idx) => {
        if (e.orderNo === param.orderNo) {
          orderListState[idx].orderState = param.orderState;
        }
      });
    }
    toastAlert(`주문상태 변경에 ${data ? '성공했습니다.' : '실패했습니다.'}`, data ? FORM.SUCCESS : FORM.ERROR);

    return status === ServiceExec.status.OK && data;
  },
  PARTIAL_CANCEL: async ({ commit }, params) => {
    const { state, data } = await ServiceExec.patch(partialRefund, params);
    return data;
  }
};
